import { render, staticRenderFns } from "./relCriticasValeTransporte.vue?vue&type=template&id=54b7e79f"
import script from "./relCriticasValeTransporte.vue?vue&type=script&lang=ts"
export * from "./relCriticasValeTransporte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports